import React from 'react';
import { string } from 'prop-types';

import ArrowLeftCircle from '../components/atoms/icons/ArrowLeftCircle';
import { useTranslate } from '../translate/I18n';
import Button from '../components/elements/Button';
import SanitizedHTML from '../components/elements/SanitizedHTML';
import { useRouter } from './router';

const TextPage = ({ page }) => {
  const history = useRouter();
  const { t } = useTranslate(['legalPages', 'privacyPolicy']);
  return (
    <section className="section__search col-12 p mb">
      <div className="container__center">
        <div className="col-12 col-10-md p m-auto">
          <Button onClick={() => history.goBack()} className="btn-md transparent trimmed ph-none t-grey-dark block">
            <ArrowLeftCircle />
            {t('common:back')}
          </Button>
          <h2>
            <SanitizedHTML className="html-content" content={t(`${page}:title`)} />
          </h2>
          <SanitizedHTML className="html-content" content={t(`${page}:content`)} />
        </div>
      </div>
    </section>
  );
};

TextPage.propTypes = {
  page: string
};
export default TextPage;
